import * as React from "react";

const Header = ({ siteTitle }) => <header></header>;

export default Header;
